var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKnees(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "37px",
    height: "22px",
    viewBox: "0 0 41 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Knees") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Humanuculus",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fillOpacity: 0.195858829
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-Copy-20",
    transform: "translate(-68.000000, -252.000000)",
    fill: "#1E428A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.1301334,252 L86.5,274 L68.5,274 C69.090121,268.925724 69.3851814,265.135396 69.3851814,262.629018 C69.3851814,260.12264 69.2244678,256.579634 68.9030406,252 L87.1301334,252 Z M107.448404,252 C107.312769,256.579634 107.244952,260.12264 107.244952,262.629018 C107.244952,265.135396 107.540012,268.925724 108.130133,274 L108.130133,274 L90.1301334,274 L89.5,252 Z",
    id: "Knees"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnees);
export default __webpack_public_path__ + "static/media/Knees.f0f2e6947cbafa6589bb894a4c067d9e.svg";
export { ForwardRef as ReactComponent };